import React from 'react';
import { toast } from 'react-toastify';
import { /* CheckCircle, HighlightOff, */ Close } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import styled from '@emotion/styled';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToast.css';
import { GamifyIcon } from '../components/GamifyIcon';

const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

const CloseIconContainer = styled.div``;

const BaseToast = ({ title, subtitle, borderColor, icon, iconColor }) => (
  <Box
    sx={{
      '::after': {
        top: 0,
        left: 0,
        content: '""',
        width: '7px',
        height: '100%',
        position: 'absolute',
        display: 'inline-block',
        backgroundColor: borderColor,
      },
    }}
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      backgroundColor: '#3b3f46',
      color: 'white',
      minHeight: 64,
      padding: '16px',
      textAlign: 'left',
      borderRadius: '8px',
    }}
  >
    <IconContainer>
      <GamifyIcon icon={icon} width={24} height={24} color={iconColor} />
    </IconContainer>
    <Box
      style={{
        flex: 1,
        marginLeft: '8px',
      }}
    >
      <Typography style={{ fontSize: '15px', fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography style={{ fontSize: '12px', fontWeight: 400 }}>
        {subtitle}
      </Typography>
    </Box>
    <CloseIconContainer>
      <IconButton sx={{ padding: 0 }} color="inherit" size="small">
        <Close />
      </IconButton>
    </CloseIconContainer>
  </Box>
);

const SuccessToast = ({ title, subtitle }) => (
  <BaseToast
    title={title}
    subtitle={subtitle}
    borderColor="#01CEAC"
    icon="check"
  />
);

const ErrorToast = ({ title, subtitle }) => (
  <BaseToast
    title={title}
    subtitle={subtitle}
    borderColor="#E35050"
    icon="warning"
  />
);

const InfoToast = ({ title, subtitle }) => (
  <BaseToast
    title={title}
    subtitle={subtitle}
    borderColor="#3498db"
    icon="info"
    iconColor="#3498db"
  />
);

const defaultOptions = {
  autoClose: 3500,
  position: toast.POSITION.TOP_RIGHT,
};

const GamifyToast = {
  ...toast,
  success: (title, subtitle, options) => {
    toast(<SuccessToast title={title} subtitle={subtitle} />, {
      ...options,
      ...defaultOptions,
      closeButton: false,
      progressStyle: {
        background: '#01CEAC',
      },
    });
  },
  error: (title, subtitle, options) => {
    toast(<ErrorToast title={title} subtitle={subtitle} />, {
      ...options,
      ...defaultOptions,
      closeButton: false,
      progressStyle: {
        background: '#E35050',
      },
    });
  },
  info: (title, subtitle, options) => {
    toast(<InfoToast title={title} subtitle={subtitle} />, {
      ...options,
      ...defaultOptions,
      closeButton: false,
      progressStyle: {
        background: '#3498db',
      },
    });
  },
};

export { SuccessToast, ErrorToast, InfoToast, GamifyToast };
